import {ANNOTATION_TYPES} from '../../constants/dia';
import stringHelper from '../../helpers/stringHelper';

export const getSortedAnnotations = (items = [], elementIds = [], categories = []) => {
  let myItems = JSON.parse(JSON.stringify(items));
  myItems.forEach(item => {
    item.attributes.category = getCategory(item, elementIds);
  });
  let typeOrder = JSON.parse(JSON.stringify(ANNOTATION_TYPES));
  myItems.sort((a, b) => {
    let aType = a.attributes.annotation_type;
    let bType = b.attributes.annotation_type;
    if (aType !== bType) {
      return typeOrder.indexOf(aType) - typeOrder.indexOf(bType);
    }
    let aCat = a.attributes.category;
    let bCat = b.attributes.category;
    if (!aCat && !bCat) {
      return a.attributes.order - b.attributes.order;
    }
    if (!aCat) {
      return 1;
    }
    if (!bCat) {
      return -1;
    }
    // if (aCat !== bCat) {
    //   return categories.indexOf(aCat) - categories.indexOf(bCat);
    // }
    return a.attributes.order - b.attributes.order;
  });
  myItems.forEach((item) => {
    if (item.attributes && item.attributes.body) {
      item.attributes.body = stringHelper.optimizeHtml(item.attributes.body);
    }
  });
  return myItems;

  function getCategory(item, elementIds) {
    return item.attributes.category ? item.attributes.category.label : null;
  }
};



/** WEBPACK FOOTER **
 ** ./src/modules/annotations/selectors.js
 **/